/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityContactResult } from './ControlEntityContactResult';
import {
    ControlEntityContactResultFromJSON,
    ControlEntityContactResultFromJSONTyped,
    ControlEntityContactResultToJSON,
} from './ControlEntityContactResult';

/**
 * 
 * @export
 * @interface ControlAddOrUpdateEntityContactResponse
 */
export interface ControlAddOrUpdateEntityContactResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlAddOrUpdateEntityContactResponse
     */
    external_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAddOrUpdateEntityContactResponse
     */
    contact_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAddOrUpdateEntityContactResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAddOrUpdateEntityContactResponse
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlAddOrUpdateEntityContactResponse
     */
    immutable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlAddOrUpdateEntityContactResponse
     */
    contact_type?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAddOrUpdateEntityContactResponse
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAddOrUpdateEntityContactResponse
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAddOrUpdateEntityContactResponse
     */
    cadency?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAddOrUpdateEntityContactResponse
     */
    search?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlAddOrUpdateEntityContactResponse
     */
    disabled?: boolean;
}

/**
 * Check if a given object implements the ControlAddOrUpdateEntityContactResponse interface.
 */
export function instanceOfControlAddOrUpdateEntityContactResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlAddOrUpdateEntityContactResponseFromJSON(json: any): ControlAddOrUpdateEntityContactResponse {
    return ControlAddOrUpdateEntityContactResponseFromJSONTyped(json, false);
}

export function ControlAddOrUpdateEntityContactResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAddOrUpdateEntityContactResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'external_id': !exists(json, 'external_id') ? undefined : json['external_id'],
        'contact_id': !exists(json, 'contact_id') ? undefined : json['contact_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'immutable': !exists(json, 'immutable') ? undefined : json['immutable'],
        'contact_type': !exists(json, 'contact_type') ? undefined : json['contact_type'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
        'cadency': !exists(json, 'cadency') ? undefined : json['cadency'],
        'search': !exists(json, 'search') ? undefined : json['search'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function ControlAddOrUpdateEntityContactResponseToJSON(value?: ControlAddOrUpdateEntityContactResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'external_id': value.external_id,
        'contact_id': value.contact_id,
        'name': value.name,
        'email': value.email,
        'immutable': value.immutable,
        'contact_type': value.contact_type,
        'created': value.created,
        'updated': value.updated,
        'cadency': value.cadency,
        'search': value.search,
        'disabled': value.disabled,
    };
}

